<template>
      <aside class="cart" :class="{ 'active': show }" >
            <div class="flex">
                  <div>CART</div>
                  <div role="button" class="remove-link" @click="show = false">
                        <span>C</span><span>L</span><span>O</span><span>S</span><span>E</span>
                  </div>
            </div>
            <div v-if="cart.length > 0" class="items">
                  <div>ITEMS</div>
                  <div v-for="(item, index) in cart" :key="index" class="item">
                        <div>
                              <img :src="item.content.cover.url" :alt="item.title">
                        </div>
                        <div>
                              {{ item.title }}<br>
                              {{ item.quantity }} ✕ € {{ item.content.price }}<br>
                              <div class="remove-link" @click="removeFromCart(item)"><span>R</span><span>E</span><span>M</span><span>O</span><span>V</span><span>E</span></div>
                        </div>
                  </div>
            </div>
            <div v-if="cart.length > 0"  class="flex">
                 <div>TOTAL</div>
                 <div class="text-right">
                        € {{ total.toFixed(2) }}<br>
                        + SHIPPING
                  </div>
            </div>
            <div v-if="cart.length > 0" >
                  <button @click="checkOut" class="checkout-button">
                        <span>C</span>
                        <span>H</span>
                        <span>E</span>
                        <span>C</span>
                        <span>K</span>
                        <span>O</span>
                        <span>U</span>
                        <span>T</span>
                  </button>
            </div>
            <div v-if="cart.length > 0" >Terms & Conditions Apply</div>
            <div v-if="cart.length == 0" class="cart-empty">
                  <h2>
                        <span>E</span><span>M</span><span>P</span><span>T</span><span>Y</span>
                  </h2>
            </div>
      </aside>
</template>

<script>
import Client from 'shopify-buy';
export default{
      data() {
            return {
                  show: false,
                  client: null,
            }
      },
      computed: {
            cart() {
                  return this.$store.state.cart;
            },
            total() {
                  return this.$store.getters.totalAmount;
            }
      },
      mounted() {
            this.loadClient();
            this.$root.$on('openCart', () => {
                  this.show = true;
            })
      },
      methods: {
            loadClient() {
                  this.client = Client.buildClient({
                        domain: 'estelle-bourdet.myshopify.com',
                        storefrontAccessToken: '6bc5bb9b7d64afa45a01117b6e31e6fc',
                  });
                //   console.log(this.client);
            },
            async checkOut() {
                //   console.log('checkout')
                  const checkout = await this.client.checkout.create();
                //   console.log(checkout);
                  const checkoutItems = this.cart.map((item) => {
                        console.log(item);
                        return {
                              variantId: item.content.variants[Object.keys(item.content.variants)[0]].api_id,
                              quantity: item.quantity
                        }
                  });
                //   console.log(checkoutItems);
                  await this.client.checkout.addLineItems(checkout.id, checkoutItems);
                //   console.log(res);
                  window.location.href = checkout.webUrl;
            },
            removeFromCart(item) {
                  this.$store.commit('removeFromCart', item.uid);
            }
      }
}
</script>

<style lang="scss" scoped>
.text-right {
      text-align: right;
}
aside {
      background-color: rgba(255,255,255,1);
      position: fixed;
      top: 0;
      right: 0;
      width: 33vw;
      height: 100%;
      overflow-y: auto;
      padding:1rem;
      z-index: 999;
      transform: translateX(100%);
      transition: transform 0.3s ease-in-out;
      display: flex;
      flex-direction: column;
      @media only screen and (max-width:1024px) {
            width:50vw;
      }
      @media only screen and (max-width:768px) {
            width:100%;
      }
      &> div:not(:first-child) {
            margin-top: 1rem;
      }
      .flex {
            display: flex;
            justify-content: space-between;
      }
      .items {
            flex-grow:1;
            .item {
                  margin-top:1rem;
                  display: grid;
                  grid-template-columns: 1fr 2fr;
                  grid-gap: 1em;
                  img { width:100%; }
            }
      }
      .cart-empty {
            flex-grow:1;
            display: flex;
            justify-content: center;
            align-items: center;
            span {
                  display: inline-block;
                  &:nth-child(1) {
                        transform: translateY(-20%);
                  }
                  &:nth-child(2) {
                        transform: translateY(15%);
                  }
                  &:nth-child(3) {
                        transform: translateY(-5%);
                  }
                  &:nth-child(4) {
                        transform: translateY(5%);
                  }
                  &:nth-child(5) {
                        transform: translateY(10%);
                  }
                  &:nth-child(6) {
                        transform: translateY(-5%);
                  }
            }
      }
}
aside.active {
      transform: translateX(0);
}
button.checkout-button {
            font-family: "Walter", sans-serif;
            -webkit-font-smoothing: antialiased;
            -moz-osx-font-smoothing: grayscale;
            font-variant-ligatures: none;
            font-feature-settings: "liga" 0, "clig" 0;
            font-size: 0.9rem;
            letter-spacing: 0.3em;
            line-height: 1.3;
            background: #e9e6e6;
            padding:0.75em 0.8em 0.5em 1em;
            text-transform: uppercase;
            appearance: none;
            border: 0px;
            cursor:pointer;
            span {
                  display:inline-block;
                  transition: transform 0.2s ease-in-out;
            }
            &:hover span:nth-child(1) {
                  transform: translateY(-20%);
            }
            &:hover span:nth-child(2) {
                  transform: translateY(15%);
            }
            &:hover span:nth-child(3) {
                  transform: translateY(-5%);
            }
            &:hover span:nth-child(4) {
                  transform: translateY(5%);
            }
            &:hover span:nth-child(5) {
                  transform: translateY(10%);
            }
            &:hover span:nth-child(6) {
                  transform: translateY(-5%);
            }
            &:hover span:nth-child(7) {
                  transform: translateY(-15%);
            }
      }
.remove-link {
      cursor: pointer;
      span {
            display:inline-block;
            transition: transform 0.2s ease-in-out;
      }
      &:hover span:nth-child(1) {
            transform: translateY(-10%);
      }
      &:hover span:nth-child(2) {
            transform: translateY(15%);
      }
      &:hover span:nth-child(3) {
            transform: translateY(-5%);
      }
      &:hover span:nth-child(4) {
            transform: translateY(5%);
      }
      &:hover span:nth-child(5) {
            transform: translateY(10%);
      }
      &:hover span:nth-child(6) {
            transform: translateY(-5%);
      }
      &:hover span:nth-child(7) {
            transform: translateY(-15%);
      }
}
</style>